import {
  NGX_MAT_DATE_FORMATS,
  NgxMatDateFormats,
  NgxMatDatetimePickerModule,
  NgxMatNativeDateModule,
  NgxMatTimepickerModule,
} from '@angular-material-components/datetime-picker';
import {
  NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  NgxMatMomentModule,
} from '@angular-material-components/moment-adapter';
import { LayoutModule } from '@angular/cdk/layout';
import { OverlayModule } from '@angular/cdk/overlay';
import { DatePipe, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import localePT from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CookieService } from 'ngx-cookie-service';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SocketIoModule } from 'ngx-socket-io';

import { AppComponent } from './app.component';
import { environment } from './config/environments/environment';
import { AuthInterceptor } from './data/interceptors/authinterceptor.interceptor';
import { UnauthorizedInterceptor } from './data/interceptors/unauthorized.interceptor';
import { AppFirebaseModule } from './modules/app-firebase.module';
import { MaterialModule } from './modules/app-material.module';
import { AppRoutingModule } from './modules/app-routing.module';
import { AppServicesModule } from './modules/app-services.module';
import { ArrivalModule } from './modules/arrival/arrival.module';
import { ChannelsModule } from './modules/channels/channels.module';
import { LinksModule } from './modules/links/links.module';
import { NewsModule } from './modules/news/news.module';
import { SharedModule } from './modules/shared/shared.module';
import { BottomSheetConfirmationComponent } from './ui/components/bottom-sheet-confirmation/bottom-sheet-confirmation.component';
import { BottomSheetOccasionComponent } from './ui/components/bottom-sheet-occasion/bottom-sheet-occasion.component';
import { ButtonLinkYearClassroomsComponent } from './ui/components/button-link-year-classrooms/button-link-year-classrooms.component';
import { ButtonTreeDialogComponent } from './ui/components/button-tree-dialog/button-tree-dialog.component';
import { ChatFileComponent } from './ui/components/chat-file/chat-file.component';
import { CustomDateTimePickerComponent } from './ui/components/custom-date-time-picker/custom-date-time-picker.component';
import { CustomSnackbarComponent } from './ui/components/custom-snackbar/custom-snackbar.component';
import { DynamicFormComponent } from './ui/components/form/dynamic-form/dynamic-form.component';
import { FormItemComponent } from './ui/components/form/form-item/form-item.component';
import { FormDialogComponent } from './ui/components/form-dialog/form-dialog.component';
import { GateCardComponent } from './ui/components/gate-card/gate-card.component';
import { GenericDialogComponent } from './ui/components/generic-dialog/generic-dialog.component';
import { HelpDialogComponent } from './ui/components/help-dialog/help-dialog.component';
import { HelpUserProfilesDialogComponent } from './ui/components/help-user-profiles-dialog/help-user-profiles-dialog.component';
import { LinkYearClassroomsComponent } from './ui/components/link-year-classrooms/link-year-classrooms.component';
import { NavSidebarComponent } from './ui/components/nav-sidebar/nav-sidebar.component';
import { PushNotificationDialogComponent } from './ui/components/push-notification-dialog/push-notification-dialog.component';
import { PushNotificationComponent } from './ui/components/push-notification/push-notification.component';
import { SimpleLogSheetComponent } from './ui/components/simple-log-sheet/simple-log-sheet.component';
import { SnackBarComponent } from './ui/components/snack-bar/snack-bar.component';
import { TreeFormComponent } from './ui/components/tree-form/tree-form.component';
import { TreeComponent } from './ui/components/tree/tree.component';
import { UserAddedCardComponent } from './ui/components/user-added-card/user-added-card.component';
import { UserCardComponent } from './ui/components/user-card/user-card.component';
import { ChildrenDetailsComponent } from './ui/components/user-details/children-details/children-details.component';
import { ParentsDetailsComponent } from './ui/components/user-details/parents-details/parents-details.component';
import { UserDetailsComponent } from './ui/components/user-details/user-details.component';
import { UserHeaderComponent } from './ui/components/user-header/user-header.component';
import { AuthLayoutComponent } from './ui/layouts/auth-layout/auth-layout.component';
import { PublicLayoutComponent } from './ui/layouts/public-layout/public-layout.component';
import { GateFormComponent } from './ui/pages/arrival/gate/gate-form/gate-form.component';
import { GateListComponent } from './ui/pages/arrival/gate/gate-list/gate-list.component';
import { ForgotPasswordComponent } from './ui/pages/auth/forgot-password/forgot-password.component';
import { LoginBypassComponent } from './ui/pages/auth/login-bypass/login-bypass.component';
import { LoginComponent } from './ui/pages/auth/login/login.component';
import { ResetPasswordComponent } from './ui/pages/auth/reset-password/reset-password.component';
import { ChatInitialComponent } from './ui/pages/chats/chat-initial/chat-initial.component';
import { ChatRemovedMessageComponent } from './ui/pages/chats/chat-removed-message/chat-removed-message.component';
import { ChatForwardMessageComponent } from './ui/pages/chats/chats-details/chat-forward-message/chat-forward-message.component';
import { ChatForwardRoomComponent } from './ui/pages/chats/chats-details/chat-forward-room/chat-forward-room.component';
import { ChatsDetailsItemComponent } from './ui/pages/chats/chats-details/chats-details-item/chats-details-item.component';
import { ChatsDetailsComponent } from './ui/pages/chats/chats-details/chats-details.component';
import { ChatItemArchiveComponent } from './ui/pages/chats/chats-messages-list/chat-item-archive/chat-item-archive/chat-item-archive.component';
import { ChatItemComponent } from './ui/pages/chats/chats-messages-list/chat-item/chat-item.component';
import { ChatsMessagesListComponent } from './ui/pages/chats/chats-messages-list/chats-messages-list.component';
import { ChatsPageComponent } from './ui/pages/chats/chats.component';
import { EventComponent } from './ui/pages/events/event.component';
import { EventsListComponent } from './ui/pages/events/events-list/events-list.component';
import { PageNotFoundComponent } from './ui/pages/page-not-found/page-not-found.component';
import { RedirectToAppStoresComponent } from './ui/pages/redirect-to-app-stores/redirect-to-app-stores.component';
import { RegisterComponent } from './ui/pages/register/register.component';
import { UserFormComponent } from './ui/pages/user-list/form/user-fom/user-form.component';
import { UserListComponent } from './ui/pages/user-list/user-list.component';
import { ChatItemMenuComponent } from './ui/pages/chats/chats-messages-list/chat-item/chat-item-menu/chat-item-menu.component';
import { ShowsModule } from './modules/shows/shows.module';
import { TicketsModule } from './modules/tickets/tickets.module';
import { ChatItemActiveTicketComponent } from './ui/pages/chats/chats-messages-list/chat-item-active-ticket/chat-item-active-ticket.component';
import { SelectTenantComponent } from './ui/pages/auth/select-tenant/select-tenant.component';
import { SelectTenantDialogComponent } from './ui/pages/auth/select-tenant-dialog/select-tenant-dialog.component';
import { SelectSchoolComponent } from './ui/pages/auth/select-school/select-school.component';
import { NetworkSnackbarComponent } from './ui/components/network-snackbar/network-snackbar.component';

export const MOMENT_DATETIME_WITH_SECONDS_FORMAT = 'DD/MM/YYYY HH:mm';

// If using Moment
const CUSTOM_MOMENT_FORMATS: NgxMatDateFormats = {
  parse: {
    dateInput: MOMENT_DATETIME_WITH_SECONDS_FORMAT,
  },
  display: {
    dateInput: MOMENT_DATETIME_WITH_SECONDS_FORMAT,
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

registerLocaleData(localePT);
@NgModule({
  declarations: [
    AppComponent,
    EventsListComponent,
    ChatsPageComponent,
    ChatsDetailsComponent,
    PageNotFoundComponent,
    NavSidebarComponent,
    LoginComponent,
    RegisterComponent,
    SnackBarComponent,
    NetworkSnackbarComponent,
    ChatsMessagesListComponent,
    FormItemComponent,
    DynamicFormComponent,
    UserListComponent,
    UserCardComponent,
    UserFormComponent,
    EventComponent,
    TreeComponent,
    TreeFormComponent,
    ButtonTreeDialogComponent,
    UserHeaderComponent,
    CustomDateTimePickerComponent,
    HelpUserProfilesDialogComponent,
    PushNotificationComponent,
    PushNotificationDialogComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    AuthLayoutComponent,
    PublicLayoutComponent,
    UserDetailsComponent,
    UserAddedCardComponent,
    BottomSheetOccasionComponent,
    GateListComponent,
    GateFormComponent,
    GateCardComponent,
    BottomSheetConfirmationComponent,
    CustomSnackbarComponent,
    SimpleLogSheetComponent,
    LinkYearClassroomsComponent,
    ButtonLinkYearClassroomsComponent,
    HelpDialogComponent,
    ChatItemComponent,
    GenericDialogComponent,
    FormDialogComponent,
    RedirectToAppStoresComponent,
    ChatFileComponent,
    LoginBypassComponent,
    ChatInitialComponent,
    ChatsDetailsItemComponent,
    ChatRemovedMessageComponent,
    ParentsDetailsComponent,
    ChildrenDetailsComponent,
    ChatForwardMessageComponent,
    ChatForwardRoomComponent,
    ChatItemMenuComponent,
    ChatItemArchiveComponent,
    ChatItemActiveTicketComponent,
    SelectTenantComponent,
    SelectTenantDialogComponent,
    SelectSchoolComponent,
  ],
  imports: [
    AppFirebaseModule,
    BrowserModule,
    MaterialModule,
    LayoutModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    FlexLayoutModule,
    SocketIoModule.forRoot(environment.socketIoConfig),
    AppServicesModule,
    NgxMatTimepickerModule,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    MatDatepickerModule,
    NgxMatMomentModule,
    ArrivalModule,
    SharedModule,
    ChannelsModule,
    LinksModule,
    NewsModule,
    InfiniteScrollModule,
    OverlayModule,
    ShowsModule,
    TicketsModule
  ],
  providers: [
    CookieService,
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UnauthorizedInterceptor,
      multi: true,
    },
    { provide: NGX_MAT_DATE_FORMATS, useValue: CUSTOM_MOMENT_FORMATS },
    {
      provide: NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS,
      useValue: { useUtc: false },
    },
    { provide: LOCALE_ID, useValue: 'pt' },
  ],
  bootstrap: [AppComponent],
  exports: [FormItemComponent, DynamicFormComponent],
})
export class AppModule {}
